"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSessionStorage = exports.getSessionStorage = exports.clearLocalStorage = exports.removeLocalStorage = exports.setLocalStorage = exports.getLocalStorage = exports.getKey = exports.prefix = void 0;
exports.prefix = "HoT";
const getKey = (key) => {
    return `${exports.prefix}:${key}`;
};
exports.getKey = getKey;
const getLocalStorage = (key) => {
    if (typeof localStorage !== "undefined") {
        const value = localStorage.getItem(key);
        try {
            return JSON.parse(value);
        }
        catch (_a) {
            return value;
        }
    }
    return null;
};
exports.getLocalStorage = getLocalStorage;
const setLocalStorage = (key, value) => {
    return localStorage.setItem(key, typeof value === "object" ? JSON.stringify(value) : value);
};
exports.setLocalStorage = setLocalStorage;
const removeLocalStorage = (key) => {
    return localStorage.removeItem(key);
};
exports.removeLocalStorage = removeLocalStorage;
const clearLocalStorage = () => {
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (typeof key === "string" && key.startsWith(exports.prefix)) {
            localStorage.removeItem(key);
        }
    }
};
exports.clearLocalStorage = clearLocalStorage;
const getSessionStorage = (key) => {
    if (typeof sessionStorage !== "undefined") {
        const value = sessionStorage.getItem(key);
        try {
            return JSON.parse(value);
        }
        catch (_a) {
            return value;
        }
    }
    return null;
};
exports.getSessionStorage = getSessionStorage;
const setSessionStorage = (key, value) => {
    if (typeof sessionStorage !== "undefined") {
        return sessionStorage.setItem(key, typeof value === "object" ? JSON.stringify(value) : value);
    }
    return;
};
exports.setSessionStorage = setSessionStorage;
